module.exports = __webpack_public_path__ + "static/media/avatar_chick.1275ec63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_chick.png
// module id = 372
// module chunks = 0